<template>
  <d2-container>
    <!-- 顶部操作栏 -->
    <div class="page-header">
      <div class="header-left">
        <h2 class="page-title">动画管理</h2>
      </div>
      <div class="header-actions">
        <el-button type="primary" size="medium" icon="el-icon-upload" @click="openUploadDialog">
          上传动画
        </el-button>
        <el-button type="success" size="medium" icon="el-icon-magic-stick" @click="openDesigner">
          创建动画
        </el-button>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="table-container">
      <el-table :data="list" border stripe class="animated-table">
      <el-table-column prop="id" label="ID" align="center" width="80" />
      <el-table-column prop="name" label="名称" align="center" />
      <el-table-column prop="url" label="动画预览" align="center" width="220">
        <template slot-scope="scope">
          <div v-if="scope.row.url" class="animation-preview">
            <AnimationCanvas :url="scope.row.url" :width="180" :height="150" />
          </div>
          <div v-else class="no-animation">
            <i class="el-icon-picture-outline"></i>
            <span>暂无动画</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="introduce" label="简介" align="center" />
      <el-table-column label="操作" align="center" width="220">
        <template slot-scope="scope">
          <div class="action-buttons">
            <el-button size="mini" type="primary" icon="el-icon-edit" @click="openDialog('edit', scope.row)" plain>
              编辑
            </el-button>
            <el-button size="mini" type="success" icon="el-icon-s-tools" @click="openDesignerWithId(scope.row.id)" plain>
              设计器
            </el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row.id)" plain>
              删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
        :page-size="query.pageSize"
        :current-page="query.currentPage"
        @current-change="handlePageChange"
      />
    </div>
    </div>

    <!-- 上传动画弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="500px"
      @close="resetForm"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入动画名称" />
        </el-form-item>
        <el-form-item label="动画文件" prop="url">
          <UploadImage
            v-model="form.url"
            :max="1"
            :width="120"
            :text="['图片大小200KB以内', '支持GIF格式动画']"
            :showTips="true"
            :showSelFile="false"
            @change="handleFileChange"
          />
        </el-form-item>
        <el-form-item label="简介" prop="introduce">
          <el-input
            v-model="form.introduce"
            type="textarea"
            rows="3"
            placeholder="请输入动画简介"
          />
        </el-form-item>
        <el-form-item label="音频文件" prop="soundUrl">
          <UploadAudio
            v-model="form.soundUrl"
            :max="1"
            :text="['音频大小200KB以内', '支持MP3、WAV、AAC格式']"
            @change="handleAudioChange"
          />
        </el-form-item>
        <el-form-item v-if="form.url" label="预览">
          <div style="margin-top: 8px;">
            <AnimationCanvas :url="form.url" :width="240" :height="220" />
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>

<script>
import { getAnimList, addAnim, updateAnim, deleteAnim } from '@/api/merchant/botAnim'
import UploadImage from '@/components/uploadImage/index.vue'
import UploadAudio from '@/components/uploadAudio/index.vue'
import AnimationCanvas from '@/components/AnimationCanvas.vue'
export default {
  name: 'AnimManager',
  components: { UploadImage, UploadAudio, AnimationCanvas },
  data () {
    return {
      list: [],
      total: 0,
      query: {
        currentPage: 1,
        pageSize: 10
      },
      dialogVisible: false,
      dialogStatus: 'add',
      form: {
        id: null,
        name: '',
        url: '',
        introduce: '',
        soundUrl: ''
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        url: [{ required: true, message: '请上传动画文件', trigger: 'change' }],
        introduce: [{ required: true, message: '请输入简介', trigger: 'blur' }],
        soundUrl: [{ required: false, message: '上传音频文件或点击转码按钮', trigger: 'change' }]
      },
      submitLoading: false
    }
  },
  computed: {
    dialogTitle () {
      return this.dialogStatus === 'add' ? '上传动画' : '编辑动画'
    }
  },
  methods: {
    fetchList () {
      getAnimList({
        currentPage: this.query.currentPage,
        pageSize: this.query.pageSize
      }).then(res => {
        this.list = res.records || []
        this.total = parseInt(res.total) || 0
      })
    },
    handlePageChange (page) {
      this.query.currentPage = page
      this.fetchList()
    },
    openUploadDialog () {
      this.dialogStatus = 'add'
      this.dialogVisible = true
      this.resetForm()
    },
    openDesigner () {
      window.open('/tools/animation_designer.html', '_blank')
    },
    openDesignerWithId (id) {
      window.open(`/tools/animation_designer.html?id=${id}`, '_blank')
    },
    openDialog (status, row) {
      if (status === 'edit' && row) {
        this.dialogStatus = 'edit'
        this.form = { ...row }
        this.dialogVisible = true
      }
    },
    handleDelete (id) {
      this.$confirm('确定要删除该动画吗？', '提示', { type: 'warning' })
        .then(() => {
          deleteAnim(id).then(() => {
            this.$message.success('删除成功')
            this.fetchList()
          })
        })
    },
    handleFileChange (val) {
      this.form.url = val
      // 如果清空了文件，确保表单验证触发
      if (this.$refs.form) {
        this.$refs.form.validateField('url')
      }
    },
    handleAudioChange (val) {
      // 确保soundUrl是字符串类型，而不是数组
      if (Array.isArray(val)) {
        this.form.soundUrl = val.length > 0 ? val[0] : ''
      } else {
        this.form.soundUrl = val || ''
      }
      // 触发表单验证
      if (this.$refs.form) {
        this.$refs.form.validateField('soundUrl')
      }
    },
    resetForm () {
      this.form = {
        id: null,
        name: '',
        url: '',
        introduce: '',
        soundUrl: ''
      }
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
      this.submitLoading = false
    },
    handleSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          let promise
          if (this.dialogStatus === 'add') {
            promise = addAnim(this.form)
          } else {
            promise = updateAnim(this.form.id, this.form)
          }

          promise.then(() => {
            this.$message.success(this.dialogStatus === 'add' ? '上传成功' : '更新成功')
            this.dialogVisible = false
            this.fetchList()
          }).catch(() => {
            this.$message.error(this.dialogStatus === 'add' ? '上传失败' : '更新失败')
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>

<style scoped>
/* 页面头部样式 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 24px 32px;
  margin-bottom: 24px;
  color: white;
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.3);
}

.header-left {
  flex: 1;
}

.page-title {
  margin: 0 0 8px 0;
  font-size: 28px;
  font-weight: 600;
  color: white;
}

.page-description {
  margin: 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
}

.header-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}

.header-actions .el-button {
  border-radius: 12px;
  font-weight: 500;
  padding: 12px 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.header-actions .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

/* 表格容器样式 */
.table-container {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
}

/* 表格样式优化 */
.animated-table {
  border-radius: 8px;
  overflow: hidden;
  border: none;
}

.animated-table ::v-deep .el-table__header {
  background: #f8f9fa;
}

.animated-table ::v-deep .el-table__header th {
  background: transparent;
  color: #2c3e50;
  font-weight: 600;
  font-size: 14px;
  padding: 12px 0;
  border-bottom: 1px solid #e8eaec;
}

.animated-table ::v-deep .el-table__body tr:hover {
  background-color: #f8f9fa !important;
}

.animated-table ::v-deep .el-table__body td {
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
}

/* 动画预览样式 */
.animation-preview {
  padding: 8px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.no-animation {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  color: #999;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px dashed #ddd;
}

.no-animation i {
  font-size: 24px;
  margin-bottom: 4px;
  color: #ccc;
}

/* 操作按钮样式 */
.action-buttons {
  display: flex;
  gap: 6px;
  justify-content: center;
  flex-wrap: wrap;
}

.action-buttons .el-button {
  border-radius: 4px;
  font-weight: 500;
  margin: 1px;
}

/* 分页样式 */
.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 32px;
  padding: 24px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.pagination-container ::v-deep .el-pagination {
  font-weight: 500;
}

.pagination-container ::v-deep .el-pagination .el-pager li {
  border-radius: 8px;
  margin: 0 4px;
  font-weight: 500;
}

.pagination-container ::v-deep .el-pagination .el-pager li.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 8px;
}

/* 弹窗样式优化 */
.el-dialog ::v-deep .el-dialog {
  border-radius: 16px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
}

.el-dialog ::v-deep .el-dialog__header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px 16px 0 0;
  padding: 24px 32px;
}

.el-dialog ::v-deep .el-dialog__title {
  color: white;
  font-size: 18px;
  font-weight: 600;
}

.el-dialog ::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white;
  font-size: 20px;
}

.el-dialog ::v-deep .el-dialog__body {
  padding: 32px;
}

.el-dialog ::v-deep .el-form-item__label {
  font-weight: 600;
  color: #2c3e50;
}

.el-dialog ::v-deep .el-input__inner,
.el-dialog ::v-deep .el-textarea__inner {
  border-radius: 8px;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
}

.el-dialog ::v-deep .el-input__inner:focus,
.el-dialog ::v-deep .el-textarea__inner:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.dialog-footer {
  padding: 24px 32px;
  border-top: 1px solid #f0f0f0;
  background: #f8f9fa;
  border-radius: 0 0 16px 16px;
}

.dialog-footer .el-button {
  border-radius: 8px;
  font-weight: 500;
  padding: 12px 24px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    gap: 16px;
    padding: 20px;
  }

  .header-actions {
    width: 100%;
    justify-content: center;
  }

  .table-container {
    padding: 16px;
    margin: 0 -16px;
    border-radius: 0;
  }

  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }

  .action-buttons .el-button {
    width: 100%;
    margin: 0;
  }
}
</style>
